import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const LinkedIn = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M18.5455 18.1363a.4093.4093 0 01-.4091.4091h-2.4546a.4093.4093 0 01-.4091-.4091v-4.5c0-1.0244-.459-1.6364-1.2272-1.6364-.7683 0-1.2273.612-1.2273 1.6364v4.5a.4093.4093 0 01-.4091.4091H9.9546a.4093.4093 0 01-.4091-.4091V9.9545a.4092.4092 0 01.409-.4091h2.4546a.4093.4093 0 01.4091.409v.257c.5318-.4156 1.1585-.666 2.0455-.666 2.236 0 3.6818 1.6053 3.6818 4.0909v4.5zM7.0909 8.7273c-.9025 0-1.6364-.7339-1.6364-1.6363 0-.9025.734-1.6364 1.6364-1.6364.9024 0 1.6364.734 1.6364 1.6364 0 .9024-.734 1.6363-1.6364 1.6363zm1.6364 9.409a.4093.4093 0 01-.4091.4091H5.8636a.4093.4093 0 01-.409-.4091V9.9545a.4092.4092 0 01.409-.4091h2.4546a.4093.4093 0 01.409.409v8.1819zM19.3636 3H4.6364C3.7339 3 3 3.734 3 4.6364v14.7272C3 20.2661 3.734 21 4.6364 21h14.7272C20.2661 21 21 20.2661 21 19.3636V4.6364C21 3.7339 20.2661 3 19.3636 3z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M18.5455 18.1363a.4093.4093 0 01-.4091.4091h-2.4546a.4093.4093 0 01-.4091-.4091v-4.5c0-1.0244-.459-1.6364-1.2272-1.6364-.7683 0-1.2273.612-1.2273 1.6364v4.5a.4093.4093 0 01-.4091.4091H9.9546a.4093.4093 0 01-.4091-.4091V9.9545a.4092.4092 0 01.409-.4091h2.4546a.4093.4093 0 01.4091.409v.257c.5318-.4156 1.1585-.666 2.0455-.666 2.236 0 3.6818 1.6053 3.6818 4.0909v4.5zM7.0909 8.7273c-.9025 0-1.6364-.7339-1.6364-1.6363 0-.9025.734-1.6364 1.6364-1.6364.9024 0 1.6364.734 1.6364 1.6364 0 .9024-.734 1.6363-1.6364 1.6363zm1.6364 9.409a.4093.4093 0 01-.4091.4091H5.8636a.4093.4093 0 01-.409-.4091V9.9545a.4092.4092 0 01.409-.4091h2.4546a.4093.4093 0 01.409.409v8.1819zM19.3636 3H4.6364C3.7339 3 3 3.734 3 4.6364v14.7272C3 20.2661 3.734 21 4.6364 21h14.7272C20.2661 21 21 20.2661 21 19.3636V4.6364C21 3.7339 20.2661 3 19.3636 3z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
LinkedIn.displayName = "LinkedInIcon";

export { LinkedIn, LinkedIn as default };
